export default __webpack_public_path__ + "static/media/logo.30960c3f.png";